module.exports = __webpack_public_path__ + "static/img/logo.d31fd9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 59